import { render } from "./SerieFeaturedItem.vue?vue&type=template&id=5f7194ee"
import script from "./SerieFeaturedItem.vue?vue&type=script&lang=js"
export * from "./SerieFeaturedItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__